import React, { ReactElement } from "react";
import simOnly from "../../images/simonly.png";
import withOrderItems from "./withOrderItems";

interface Props {
  orderItem: any;
  labelWithTariffPackage: string;
  labelSimOnlyCard: string;
}

export const OrderItemSimOnly: React.FC<Props> = (props: Props): ReactElement => {
  const { orderItem, labelWithTariffPackage, labelSimOnlyCard } = props;
  return (
    <React.Fragment>
      <img data-test-img src={simOnly} alt="Sim card" />
      <div className={"d-inline-block text-start align-middle"}>
        <div className={"fw-bold"}>{labelSimOnlyCard}</div>
        <div>{labelWithTariffPackage}</div>
        <div className={"fw-bold"}>{orderItem.tariffPackage.name}</div>
      </div>
    </React.Fragment>
  );
};

export default withOrderItems(OrderItemSimOnly);
